// Brand assets + API client — single import surface for the funnel.
import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 60000 });

// Brand assets (uploaded by user)
export const ASSETS = {
  logoCompact: "https://customer-assets.emergentagent.com/job_machine-mind/artifacts/j87qgw8m_IMG_1259.JPG",
  logoText: "https://customer-assets.emergentagent.com/job_machine-mind/artifacts/h1hokmz7_sewing-haven-logo-text.png",
  logoEditorial: "https://customer-assets.emergentagent.com/job_machine-mind/artifacts/wghh0tff_IMG_1262.JPG",
  danielPortrait: "https://customer-assets.emergentagent.com/job_machine-mind/artifacts/k0q7osts_IMG_1348.jpeg",
  brandVideo:
    "https://customer-assets.emergentagent.com/job_machine-mind/artifacts/vdj10sh1__users_d906bd70-ddd1-4d12-a4fc-453a6df39984_generated_0fa31eb7-a7c2-423f-aa90-e6b70d1efa62_generated_video.MP4",
  // Daniel's "leaving so soon?" message — YouTube embed used in the exit-intent modal.
  exitIntentYouTubeId: "qrVDkk4WRHg",
};

export const TIERS = [
  {
    key: "monthly",
    label: "Founding Monthly",
    price: 29,
    standard: 49,
    cadence: "/mo",
    savings: "$20/mo locked permanently",
    pitch: "Try it. Stay. Lock the lowest monthly rate this app will ever have.",
    highlight: false,
  },
  {
    key: "annual",
    label: "Founding Annual",
    price: 297,
    standard: 497,
    cadence: "/yr",
    effectiveMonthly: 24.75,
    savings: "$200/yr permanent — effective $24.75/mo",
    pitch: "Best blend of commitment and savings. Renew at $297 forever.",
    highlight: true,
  },
  {
    key: "lifetime",
    label: "Founding Lifetime",
    price: 1297,
    standard: 3297,
    cadence: " once",
    savings: "$2,000 saved · pay once, never again",
    pitch: "One payment. Every module that ships. Every video. Forever.",
    highlight: false,
  },
];

export const MODULES = [
  { name: "Tension Lab", group: "Diagnostic", standalone: 19, copy: "Calibration that ends the dial-and-pray loop. Diagnose by stitch, not by guess." },
  { name: "Quilt Lab", group: "Math Tools", standalone: 59, copy: "Block, yardage, backing, binding — the math that should have been following your decisions all along." },
  { name: "Stitch-Out Simulator", group: "Embroidery", standalone: 19, copy: "Rehearse the risk before you hoop. Stop ruining $40 blanks at 9pm." },
  { name: "Alteration Atelier", group: "Garment", standalone: 39, copy: "Patterns built for the pattern's body, not yours. Compounded alteration math, finally." },
  { name: "Fit & Fix", group: "Garment", standalone: 19, copy: "Persistent measurement + alteration tracking. Your body, remembered project to project." },
  { name: "Embroidery Converter", group: "Embroidery", standalone: 199, copy: "Universal file format conversion for every machine in the room. Pro-grade output." },
  { name: "Embroidery Vault", group: "Embroidery", standalone: 9, copy: "Designs organized the way a tech would actually file them." },
  { name: "Hoop Placement", group: "Embroidery", standalone: 9, copy: "Template-based placement for shirts, towels, jackets — every item, every time." },
  { name: "Fabric Creative Studio", group: "Planning", standalone: 39, copy: "Layout visualization + stash management. See it before you cut it." },
  { name: "Educator Bob", group: "AI Coach", standalone: 39, copy: "AI for technique & machine behavior — built on Daniel's framework, not generic." },
  { name: "Copilot Sue", group: "AI Coach", standalone: 49, copy: "AI for project & creative decisions when the deadline is tomorrow." },
  { name: "Vinny's Tech Corner", group: "AI Coach", standalone: 29, copy: "AI for machine-specific & mechanical questions. The conversation that used to cost a service call." },
  { name: "Video Library", group: "Education", standalone: 49, copy: "5+ new videos every month. Not tutorials. Teaching." },
  { name: "Learning Paths", group: "Education", standalone: 79, copy: "A curriculum, not a collection. Build the framework once, use it forever." },
  { name: "Project Command Center", group: "Workflow", standalone: 19, copy: "Multi-project tracking & state — pick up where you left off, every time." },
  { name: "Community Circles", group: "Community", standalone: 9, copy: "Quilters, embroiderers, garment makers — your people in one place." },
];

export const valueOfStack = MODULES.reduce((s, m) => s + m.standalone, 0);

export const FAQ = [
  {
    q: "Is everything live today?",
    a:
      "No — and we don't want you confused about that. Tension Lab, Quilt Lab, the AI coaches, and the starter Video Library are in v1 beta with members. Most other modules are at demo+ capability, fully shipping June–August. Your founding rate is locked from day one regardless.",
  },
  {
    q: "What does \"founding rate locked permanently\" actually mean?",
    a:
      "Whatever you pay today — $29/mo, $297/yr, or $1,297 once — never goes up for you, as long as your subscription stays active. When the price moves to $49/mo and $497/yr, your account stays on the founding rate. That's a written commitment.",
  },
  {
    q: "Why a member-funded model instead of investors?",
    a:
      "Because investors would tell me to unbundle and charge per module, then optimize for retention metrics over teaching. I'd rather answer to you. No board, no pivot, no enshittification arc.",
  },
  {
    q: "Is this for beginners or advanced sewists?",
    a:
      "Both. The framework scales. Beginners build foundations they don't have to unlearn. Experienced sewists finally get the why behind problems they've been routing around for years.",
  },
  {
    q: "What if I cancel?",
    a:
      "Monthly and annual: cancel anytime, lose the founding rate. Lifetime: it's yours. No matter what, you keep what you learned.",
  },
  {
    q: "How many founding seats?",
    a:
      "We're capping the founding cohort at 500 members so I can actually onboard everyone personally. When it fills, the door closes.",
  },
];
